import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20artistic%20illustration%20style%20collage%20various%20characters%20colorful%20dynamic%20composition%20warm%20orange%20and%20coral%20tones%20soft%20gradient%20background%20abstract%20art%20decorative&width=1800&height=800&seq=hanman-hero-bg&orientation=landscape"
        alt="韩国漫画无删减下拉式免费韩漫大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-display font-bold text-background-50 leading-tight mb-4">
          韩国漫画 · 无删减 · <br className="hidden sm:block" />
          <span className="text-primary-400">下拉式免费阅读</span>
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          韩漫网站打造无删减韩国漫画下拉式免费韩漫大全平台，资源丰富多元，无广告干扰，让您享受纯净阅读时光
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-book-open-line"></i>
            立即开始阅读
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 px-8 py-3.5 rounded-full text-base font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-information-line"></i>
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-6 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">200+</p>
            <p className="text-xs text-background-300 mt-1">精选漫画</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">50万+</p>
            <p className="text-xs text-background-300 mt-1">活跃读者</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">99.8%</p>
            <p className="text-xs text-background-300 mt-1">好评率</p>
          </div>
        </div>
      </div>
    </section>
  );
}